import React from 'react';
import PropTypes from 'prop-types';
import { FiDownload, FiInfo } from 'react-icons/fi';
import Modal from '../common/Modal';
import { DOCUMENT_TYPES } from '../../utils/constants';
import './DocumentViewer.css';

const DocumentViewer = ({ document, isOpen, onClose, canDownload = false, onDownload }) => {
  if (!document || !isOpen) return null;

  const isImage = document.filename.match(/\.(jpg|jpeg|png)$/i);
  const isPdf = document.filename.match(/\.pdf$/i);
  
  const typeLabel = DOCUMENT_TYPES[document.type] || document.type;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Viewing: ${typeLabel}`} size="lg">
      <div className="document-viewer">
        <div className="viewer-sidebar">
          <h3>Metadata</h3>
          <dl className="viewer-meta">
            <dt>Filename</dt>
            <dd className="truncate" title={document.filename}>{document.filename}</dd>
            
            <dt>Type</dt>
            <dd>{typeLabel}</dd>
            
            <dt>Status</dt>
            <dd>{document.status}</dd>
            
            <dt>Uploaded</dt>
            <dd>{new Date(document.uploadedAt).toLocaleString()}</dd>
          </dl>

          <div className="viewer-notice">
            <FiInfo className="icon" />
            <p>Sensitive data may be masked based on your access level.</p>
          </div>

          {canDownload && (
            <button className="btn-primary w-100 viewer-download" onClick={() => onDownload && onDownload(document)}>
              <FiDownload style={{ marginRight: '8px' }} /> Download File
            </button>
          )}
        </div>

        <div className="viewer-main">
          {isImage && (
            <div className="viewer-image-container">
              {document.url ? (
                <img src={document.url} alt={document.filename} />
              ) : (
                <p>Loading preview...</p>
              )}
            </div>
          )}
          
          {isPdf && (
            <div className="viewer-pdf-container">
              {document.url ? (
                <iframe src={`${document.url}#toolbar=0`} title={document.filename} />
              ) : (
                <div className="pdf-placeholder">
                  <p>Loading preview...</p>
                </div>
              )}
            </div>
          )}

          {!isImage && !isPdf && (
            <div className="viewer-unsupported">
              <p>Preview not available for this file type.</p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

DocumentViewer.propTypes = {
  document: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  canDownload: PropTypes.bool,
  onDownload: PropTypes.func
};

export default DocumentViewer;
